export default __webpack_public_path__ + "static/media/osx.d67f3565.png";